module.exports = __webpack_public_path__ + "img/quote-4-white.0170ab58.webp";